import React, { Fragment } from 'react';

import withAuthServerSideProps from '@/libs/auth';

import { PageLayout, PlatForm } from '@/layouts/shared';
import { GetServerSidePropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import MetaTag from '@/components/ui/MetaTag';

const PaymentGuidePolicyPage = () => {
  const companyName = process.env.COMPANY_NAME;
  return (
    <Fragment>
      <MetaTag title="Hình thức thanh toán" description="Hình thức thanh toán" />
      <div className="container tw-mx-auto md:tw-border-t tw-border-primary-main tw-pt-8 tw-pb-10">
        <div className="tw-flex tw-gap-y-1 tw-flex-col tw-leading-7">
          <h1 className="tw-text-center tw-font-bold tw-text-lg lg:tw-text-2xl tw-mb-5 tw-uppercase">
            Hình thức thanh toán
          </h1>
          <h5 className="tw-font-semibold ">{companyName} cung cấp 2 loại thanh toán sau:</h5>
          <div className="tw-flex tw-flex-col tw-space-y-2">
            <p>- Thanh toán khi nhận hàng (COD) - Chỉ áp dụng đối với đơn hàng nội thành HCM.</p>
            <p>- Chuyển khoản qua ngân hàng.</p>
            <p>
              - Thanh toán bằng ATD: để thuận tiện cho việc mua hàng và thanh toán, quý khách hàng có thể tiến hành nạp
              tiền vào tài khoản đã đăng ký tại {companyName} với tỷ lệ quy đổi:{' '}
            </p>
            <p className="tw-text-center tw-font-semibold ">100.000 VNĐ = 01 ATD</p>
            <p>Thời gian xác nhận thanh toán bằng ATD tối đa trong 24h.</p>
            <p>Hình thức thanh toán khi nhận hàng (COD) áp dụng tại tất cả các tỉnh thành </p>
            <p>
              Bạn có thể chọn “Thanh toán khi giao hàng (COD)” hoặc “Chuyển khoản qua ngân hàng” hoặc “Thanh toán bằng
              ATD”, tùy theo nhu cầu của bạn.
            </p>
            <p>
              Đối với tất cả các đơn hàng không căn cứ vào giá trị sản phẩm hoặc vị trí nhận hàng của khách hàng phí vận
              chuyển được tính theo mức phí của hãng chuyển phát.
            </p>
            <p>
              <b>{companyName}</b> sẽ thông báo tới quý khách phí vận chuyển trước khi thực hiện vận chuyển
            </p>
            <p>Trường hợp thanh toán qua tài khoản ngân hàng. Bạn tiến hành thanh toán vào tài khoản sau:</p>
            <p>
              Số Tài Khoản: <b>896.88888</b>
            </p>
            <p>
              {' '}
              Tên Chủ Tài Khoản: <b>Nguyễn Anh Thư</b>{' '}
            </p>
            <p>
              Ngân hàng: <b>Vietinbank</b>
            </p>
            <p>
              Nội dung chuyển khoản: &quot;Thanh toán mã đơn hàng: <b>Mã Đơn Hàng</b>&ldquo;.
            </p>
            <p>Mọi thắc mắc xin vui lòng liên hệ: 033 333 6789</p>
            <p className="tw-font-semibold tw-mt-3">* Chính sách mua trả góp và thanh toán từ xa qua thẻ tín dụng:</p>
            <p>
              An Thư liên kết với bên thứ 3 để hỗ trợ Khách Hàng mua hàng trả góp và thanh toán từ xa qua thẻ tín dụng.
              Vì vậy, Khách Hàng hãy liên hệ với hệ thống kim cương An Thư để được tư vấn tùy theo từng thời điểm.
            </p>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export const getServerSideProps = withAuthServerSideProps(
  async ({ locale, query }: GetServerSidePropsContext) => {
    const platform = query?.platform || PlatForm.Web;

    return {
      props: {
        layout: PageLayout.New,
        platform,
        ...(await serverSideTranslations(locale as string, ['layout'])),
      },
    };
  },
  { isAntiAuth: false, isPublic: true }
);

export default PaymentGuidePolicyPage;
